import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';

import Heading from './Heading';
import Button from './Button';
import Image from './Image';

const ImageAndText = t(({ block, locale }) => (
  <span className="flex-row wrap">
    <Heading block={block.heading} locale={locale} />
    <Button block={block.button} locale={locale} />
    <Image block={block.image} locale={locale} />
  </span>
));

export default ImageAndText;
